import type { MouseEvent } from 'react';

// React synthetic and native DOM mouse events (e.g. a Mapbox click's originalEvent) both carry these
export type BrowserHandledClickEvent = Pick<MouseEvent, 'altKey' | 'button' | 'ctrlKey' | 'metaKey' | 'shiftKey'>;

/**
 * True when the browser should be left to handle a card/link click itself — modifier clicks that open a
 * new tab or window, and middle clicks. Callers intercept only plain clicks for client-side navigation,
 * so the native new-tab, new-window, and download affordances keep working.
 */
const isBrowserHandledClick = (event?: BrowserHandledClickEvent) =>
  Boolean(event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1));

export default isBrowserHandledClick;
